import { ToastContainer } from 'react-toastify';
import Router from './routes/routes';
import ThemeProvider from './theme';
import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';
import './app.css';
import { I18n as PolarisI18n } from '@shopify/polaris/build/esm/utilities/i18n/I18n.js';
import { fNumber } from './utils/format_number';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import 'react-toastify/dist/ReactToastify.css';
import { MountPoint } from './components/dialog/confirmation';
import { findToken } from './utils/token';
import { ToastifyCloseButton } from './components/toast_close_button';

const polarisTranslate = PolarisI18n.prototype.translate;
PolarisI18n.prototype.translate = function (id, replacements) {
  const count = replacements?.selectedItemsCount;
  if (count === undefined || !/^\d+\+?$/.test(`${count}`)) {
    return polarisTranslate.call(this, id, replacements);
  }
  const label = `${count}`.replace(/^\d+/, (digits) => fNumber(Number(digits)));
  return polarisTranslate.call(this, id, { ...replacements, selectedItemsCount: label });
};

function App() {
  findToken();
  return (
    <>
      <AppProvider i18n={enTranslations}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <ThemeProvider>
            <MountPoint />
            <Router />
          </ThemeProvider>
        </LocalizationProvider>
        <ToastContainer
          position="bottom-center"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          closeButton={<ToastifyCloseButton />}
        />
      </AppProvider>
    </>
  );
}

export default App;
